<template>
  <footer class="footer">
    <div class="container">
      <div class="footer__top">
        <p class="footer__tagline">
          Blockchain software development:<br />
          smart contracts, DeFi and Web3 products.
        </p>
        <div class="footer__links">
          <a class="footer__link" href="https://t.me/formalcrypto" target="_blank" rel="noopener">
            Telegram
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
              <path d="M3 9l6-6M4 3h5v5" stroke="currentColor" stroke-width="1.5" />
            </svg>
          </a>
          <a class="footer__link" href="#top" @click.prevent="$root.goTo('#top')">
            Back to top
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
              <path d="M6 10V2M2.5 5.5L6 2l3.5 3.5" stroke="currentColor" stroke-width="1.5" />
            </svg>
          </a>
        </div>
      </div>
      <div class="footer__mark" aria-hidden="true">
        <svg viewBox="0 0 185 22">
          <use xlink:href="#logo"></use>
        </svg>
      </div>
      <div class="footer__bottom">
        <span>© {{ year }} Formal Crypto</span>
        <span>Full-stack programmers &amp; mathematicians</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>
